/** Flat query keys that must not be treated as row filters when parsing list requests. */
const LIST_QUERY_KEYS = new Set([
  "page",
  "limit",
  "search",
  "sortBy",
  "sortOrder",
  "created_from",
  "createdFrom",
  "created_to",
  "createdTo",
  "include_user_info",
  "includeUserInfo",
  "include_inactive",
  "orgId",
  "org_id",
  "assessment_id",
  "months",
]);

/**
 * Spread filter fields as top-level query params (no filters[key] brackets).
 * Catalyst production rejects unencoded square brackets in query strings.
 */
export function flattenFilters(filters) {
  if (!filters || typeof filters !== "object" || Array.isArray(filters)) {
    return {};
  }
  const out = {};
  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === null || value === "") continue;
    out[key] = value;
  }
  return out;
}

/** Prefix criteria keys to avoid clashing with pagination params. */
export function flattenCriteria(criteria) {
  if (!criteria || typeof criteria !== "object" || Array.isArray(criteria)) {
    return {};
  }
  const out = {};
  for (const [key, value] of Object.entries(criteria)) {
    if (value === undefined || value === null || value === "") continue;
    out[`criteria_${key}`] = value;
  }
  return out;
}

export function buildListQueryParams(params = {}) {
  const {
    page,
    limit,
    search,
    sortBy,
    sortOrder,
    filters,
    criteria,
    ...rest
  } = params;

  return {
    ...(page !== undefined ? { page } : {}),
    ...(limit !== undefined ? { limit } : {}),
    ...(search ? { search } : {}),
    ...(sortBy ? { sortBy, sortOrder: sortOrder || "asc" } : {}),
    ...flattenFilters(filters),
    ...flattenCriteria(criteria),
    ...rest,
  };
}

export function isListQueryKey(key) {
  return LIST_QUERY_KEYS.has(key) || String(key).startsWith("criteria_");
}
